<template>
  <div class="big">
    <div class="page_title">商城搜索明细</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox wrap">
          <div class="item">
            <span>搜索词</span>
            <el-input placeholder="请输入"
                      v-model="search_name"
                      style="width: 200px; margin: 0 10px 0 8px"
                      clearable=""
                      @change="search"></el-input>
          </div>
          <div class="item">
            <span>应用端口</span>
            <el-select style="width: 220px; margin-left: 10px"
                       v-model="search_from"
                       placeholder="请选择"
                       multiple
                       @change="search">
              <el-option label="商城小程序"
                         :value="1"> </el-option>
              <el-option label="ios-商城"
                         :value="2"> </el-option>
              <el-option label="android-商城"
                         :value="3"> </el-option>
            </el-select>
          </div>
          <div class="item">
            <span>搜索时间</span>
            <el-date-picker v-model="date"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 230px; margin: 0 10px 0 8px"
                            @change="search">
            </el-date-picker>
            <el-button size="medium"
                       type="info"
                       @click="search"
                       style="background-color: #eceff2; color: #747981">查询</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column prop="create_time"
                             label="搜索时间"></el-table-column>
            <el-table-column label="应用端口">
              <template slot-scope="scope">
                <span v-if="scope.row.search_from == 1">商城小程序</span>
                <span v-if="scope.row.search_from == 2">ios-商城</span>
                <span v-if="scope.row.search_from == 3">android-商城</span>
              </template>
            </el-table-column>
            <el-table-column label="搜索入口">
              <template slot-scope="scope">
                {{scope.row.shop_name == ''?'首页':scope.row.shop_name}}
              </template>
            </el-table-column>
            <el-table-column prop="search_name"
                             label="搜索词"></el-table-column>
            <el-table-column prop="nick_name"
                             label="用户昵称"></el-table-column>
            <el-table-column prop="phone"
                             label="用户手机号"></el-table-column>
            <el-table-column prop="real_name"
                             label="用户真实姓名"></el-table-column>
            <el-table-column label="区域"
                             prop="address"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.user_id"
                           type="text"
                           size="medium"
                           :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('41')
                      : false
                  "
                           @click="toDetail(scope.row.user_id)">用户详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="10"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalNum"
                         style="margin: 30px 0 20px 0"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      search_name: '',
      tableData: [],
      search_from: [],
      date: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        search_name: this.search_name,
        search_from: this.search_from.toString()
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.create_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/Searchlog/getShopDetailListPaging', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm');

              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //详情
    toDetail(user_id) {
      this.$router.push({
        path: '/home/patient/userdetail',
        query: {
          user_id: user_id
        }
      });
    }
  },
  created() {
    if (this.$route.query.search_name) {
      this.search_name = this.$route.query.search_name;
      this.getList();
    } else {
      this.search_name = '';
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  .item {
    margin-bottom: 10px;
    margin-right: 20px;
  }
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
</style>
